export class Notificacao {
  titulo: string;
  mensagem: string;
  DataRegistro: Date;
  CodigoUsuario: number;
  CodigoEmpresa: number;
  dataExpiracao: Date;
  // aux not mapped
  publicoAlvo: number;
  usuarios: Array<any>;
  dataAgendamento: Date;
  agendamento: boolean = false;
  hora: any;
}
